import { gql } from "@apollo/client";

// ==========================================
// ANALYTICS - QUERIES
// ==========================================

export const GET_ANALYTICS_OVERVIEW = gql`
  query GetAnalyticsOverview($filters: AnalyticsFilters) {
    analyticsOverview(filters: $filters) {
      totalPageViews
      uniqueVisitors
      totalSessions
      bounceRate
      avgSessionDuration
      avgPagesPerSession
      totalEvents
    }
  }
`;

export const GET_ANALYTICS_TIME_SERIES = gql`
  query GetAnalyticsTimeSeries($filters: AnalyticsFilters) {
    analyticsTimeSeries(filters: $filters) {
      date
      pageViews
      visitors
      sessions
    }
  }
`;

export const GET_TRAFFIC_SOURCES = gql`
  query GetTrafficSources($filters: AnalyticsFilters) {
    trafficSources(filters: $filters) {
      source
      sessions
      pageViews
      bounceRate
      avgSessionDuration
      percentage
    }
  }
`;

export const GET_DEVICE_STATS = gql`
  query GetDeviceStats($filters: AnalyticsFilters) {
    deviceStats(filters: $filters) {
      deviceType
      sessions
      percentage
    }
  }
`;

export const GET_TOP_PAGES = gql`
  query GetTopPages($filters: AnalyticsFilters) {
    topPages(filters: $filters) {
      pagePath
      pageTitle
      views
      uniqueVisitors
      avgTimeOnPage
      avgScrollDepth
      bounceRate
    }
  }
`;

export const GET_CALCULATOR_STATS = gql`
  query GetCalculatorStatsByType($filters: AnalyticsFilters) {
    calculatorStatsByType(filters: $filters) {
      calculatorName
      calculatorType
      submissions
      conversionRate
      leadCaptureRate
      leadsCaputured
    }
  }
`;

export const GET_REALTIME_STATS = gql`
  query GetRealTimeStats {
    realTimeStats {
      activeVisitors
      activePages
      pageViewsLastHour
      eventsLastHour
    }
  }
`;

// ==========================================
// ANALYTICS - TRACKING MUTATIONS (PUBLIC)
// ==========================================

export const TRACK_PAGE_VIEW = gql`
  mutation TrackPageView($input: TrackPageViewInput!) {
    trackPageView(input: $input) {
      id
    }
  }
`;

export const UPDATE_PAGE_VIEW = gql`
  mutation UpdatePageView($input: UpdatePageViewInput!) {
    updatePageView(input: $input) {
      id
    }
  }
`;

export const TRACK_EVENT = gql`
  mutation TrackEvent($input: TrackEventInput!) {
    trackEvent(input: $input) {
      id
    }
  }
`;
